import { buildCssClassName } from "@/3514/utils"

import { EBadgeRoundVariant, EBadgeVariant } from "./badge.types"

const _baseClasses: string = "transition-colors duration-200"

const badgeColorsMap: { [K in EBadgeVariant]: (interactive: boolean, hoverable: boolean) => string } = {
    [EBadgeVariant.Yellow]: (interactive: boolean, hoverable: boolean): string =>
        buildCssClassName([
            _baseClasses,
            interactive ? "!bg-yellow-100" : hoverable && "hover:bg-yellow-100",
            "bg-yellow-200"
        ]),
    [EBadgeVariant.Green]: (interactive: boolean, hoverable: boolean): string =>
        buildCssClassName([
            _baseClasses,
            interactive ? "!bg-green-200" : hoverable && "!hover:bg-green-200",
            "bg-green-300"
        ]),
    [EBadgeVariant.LightGreen]: (interactive: boolean, hoverable: boolean): string =>
        buildCssClassName([
            _baseClasses,
            interactive ? "bg-green-300" : hoverable && "hover:bg-green-300",
            "bg-green-400"
        ]),
    [EBadgeVariant.DarkGreen]: (interactive: boolean, hoverable: boolean): string =>
        buildCssClassName([_baseClasses, interactive ? "bg-green-200" : hoverable && "hover:bg-green-200"]), // duplicate Green, remove
    [EBadgeVariant.Lightblue]: (interactive: boolean, hoverable: boolean): string =>
        buildCssClassName([
            _baseClasses,
            interactive ? "!bg-lightblue-200" : hoverable && "hover:bg-lightblue-200",
            "bg-lightblue-300"
        ])
}

const badgeRoundVariant: { [K in EBadgeRoundVariant]: string } = {
    [EBadgeRoundVariant.Small]: "rounded-[10px]",
    [EBadgeRoundVariant.Medium]: "rounded-[20px]"
}

const config = { badgeColorsMap, badgeRoundVariant }

export { config as badgeConfig }
